import React, { useRef, useCallback } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Link } from 'react-router-dom';
import { formatDateOnly } from '../../../../../utils/dateUtils';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { PSIStatusEnum } from '../hook/usePreStockInspectionData';

const PreStockInspectionTable = ({ preStockInspections, loading, handleShowHistory }) => {
    const dataTableRef = useRef(null);
    const columnsRef = useRef(null);

    const { th } = useLanguage();

    const getColumnsCallback = useCallback((el) => {
        if (el && el.getColumns && !columnsRef.current) {
            columnsRef.current = el.getColumns();
        }
        dataTableRef.current = el;
    }, []);

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="flex gap-2 justify-content-center align-items-center">
                <Link
                    to={`/warranty-management/warranty-process-forms/pre-stock-inspection-checklist/${rowData.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 hover:text-blue-700"
                    title={th('common.edit')}
                >
                    <i className="pi pi-pencil cursor-pointer" style={{ fontSize: '1.1rem' }} />
                </Link>
                <i className="pi pi-history cursor-pointer text-blue-500 hover:text-blue-700" style={{ fontSize: '1.1rem' }} title={th('warrantyClaims.tooltips.history')} onClick={() => handleShowHistory(rowData)}></i>
            </div>
        );
    };

    return (
        <DataTable
            value={preStockInspections}
            paginator
            className="p-datatable-gridlines"
            showGridlines
            rows={10}
            dataKey="id"
            loading={loading}
            filterDisplay="menu"
            emptyMessage={th('warranty.preStockInspection.table.emptyMessage')}
            rowsPerPageOptions={[5, 10, 25, 50, 100, 500, 1000]}
            tableStyle={{ minWidth: '60rem' }}
            ref={getColumnsCallback}
        >
            <Column bodyClassName="text-center" headerClassName="text-center" body={actionBodyTemplate} exportable={false} style={{ width: '5%', minWidth: '33px' }} />
            <Column sortable field="inspectorName" header={th('warranty.preStockInspection.table.inspectorName')} />
            <Column sortable field="inspectorTitle" header={th('warranty.preStockInspection.table.inspectorTitle')} />
            <Column sortable field="vin" header={th('warranty.preStockInspection.table.vin')} />
            <Column sortable field="inspectionDate" header={th('warranty.preStockInspection.table.inspectionDate')} body={(rowData) => formatDateOnly(rowData.inspectionDate)} />
            <Column sortable field="stockInDate" header={th('warranty.preStockInspection.table.stockInDate')} body={(rowData) => formatDateOnly(rowData.stockInDate)} />
            <Column
                sortable
                field="status"
                header={th('warranty.preStockInspection.table.status')}
                body={(rowData) => {
                    if (rowData.status === PSIStatusEnum.DRAFT) return th('warranty.preStockInspection.table.draft');
                    if (rowData.status === PSIStatusEnum.SENDTOKARSAN) return th('warranty.preStockInspection.table.sent');
                    return th('warranty.preStockInspection.table.unknown');
                }}
            />
            <Column header={th('warranty.preStockInspection.table.okNok')} headerClassName="text-center" bodyClassName="text-center" body={(rowData) => `${rowData.okCount} /  ${rowData.nokCount}`} style={{ minWidth: '4rem' }} />
            <Column sortable field="createdName" header={th('warranty.preStockInspection.table.createdName')} />

            <Column sortable field="createdTimestamp" header={th('warranty.preStockInspection.table.createdTimestamp')} body={(rowData) => formatDateOnly(rowData.createdTimestamp)} />
        </DataTable>
    );
};

export default PreStockInspectionTable;
